import cn from 'classnames';
import React from 'react';

import { Button, Icon, Sheet, Typography } from '@sravni/react-design-system';
import { Cross } from '@sravni/react-icons';
import { useIsMobile } from '@sravni/react-utils';

import { PanelHeader } from '@components/Map/Panel/PanelHeader';

import type { IItem } from '../interface';

import style from './style.module.scss';

interface IPanelProps {
  className?: string;
  branch: IItem | null;
  onClose: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const Panel: React.FC<IPanelProps> = (props: IPanelProps) => {
  const { className, branch, onClose } = props;
  const isMobile = useIsMobile();

  const content = (
    <>
      <div className={style['content-block']}>
        <Typography.Text size={12} className="h-color-D30">
          Адрес
        </Typography.Text>
        <Typography.Text>{branch?.address}</Typography.Text>
      </div>
      <div className={style['content-block']}>
        <Typography.Text size={12} className="h-color-D30">
          Часы работы
        </Typography.Text>
        <Typography.Text>{branch?.workTime}</Typography.Text>
      </div>
      <div className={style['content-block']}>
        <Typography.Text size={12} className="h-color-D30">
          Телефон
        </Typography.Text>
        <Typography.Text>{branch?.phone}</Typography.Text>
      </div>
    </>
  );

  if (isMobile) {
    return (
      <Sheet visible={Boolean(branch)}>
        {branch && (
          <Sheet.Header>
            <PanelHeader branchName={branch.name} />
          </Sheet.Header>
        )}
        <Sheet.Content>{content}</Sheet.Content>
        <Sheet.Footer>
          <Button className={style.btn} variant="primary" color="blue" onClick={onClose}>
            Закрыть
          </Button>
        </Sheet.Footer>
      </Sheet>
    );
  }

  return branch ? (
    <div className={cn(style.wrapper, className)}>
      <div className={style.content}>
        <div className={style['close-button']}>
          <Icon icon={<Cross />} onClick={onClose} />
        </div>
        <div className={style['content-block-name']}>
          <PanelHeader branchName={branch.name} />
        </div>
        {content}
      </div>
    </div>
  ) : null;
};

export default Panel;
